import { CrudFormStore } from "../../core/store/base_store";
import { TaskHttpRepository } from "./task_http_repository";
import { TaskValidationModel } from "./task_model";
import makeAutoObservable from "mobx-store-inheritance";
import { runInAction } from "mobx";
import { HttpMethod } from "../../core/repository/http_repository";

export class TasksStore extends CrudFormStore<TaskValidationModel, unknown, TaskHttpRepository> {
  repository = new TaskHttpRepository();
  viewModel = new TaskValidationModel();
  filters = { q: "", type: "", tag: "", status: "" };
  appliedFilters: Record<string, string> = {};
  constructor() { super(); makeAutoObservable(this); }
  async init() { await this.initCrud(); }
  read = () => Object.keys(this.appliedFilters).length
    ? this.repository.getPage(this.page, this.appliedFilters)
    : this.repository.getPage(this.page);
  setFilter(key: keyof TasksStore["filters"], value: string) { this.filters[key] = value; }
  resetFilters() { this.filters = { q: "", type: "", tag: "", status: "" }; }
  async applyFilters() {
    if (this.isLoading) return;
    this.appliedFilters = Object.fromEntries(Object.entries(this.filters).filter(([, value]) => value.trim()).map(([key, value]) => [key, value.trim()]));
    this.page = 0;
    this.models = undefined;
    await this.refresh();
  }
  async duplicate(id: string) {
    if (this.isLoading) return;
    this.errorMessage = "";
    const result = await this.httpHelper(this.repository.getOne(id));
    if (result.isFailure()) return;
    const source = result.getOrThrow();
    if (!source.task) { runInAction(() => { this.errorMessage = "У старой записи нет содержимого задания"; }); return; }
    const copy = { scoreAmount: source.scoreAmount, tags: [...source.tags], status: "draft" as const,
      task: { ...source.task, title: `${source.task.title} (копия)` } };
    const saved = await this.httpHelper(this.repository._jsonRequest<{ id: string }>(HttpMethod.POST, "/tasks", copy));
    return saved.isSuccess() ? saved.getOrThrow().id : undefined;
  }
}
